import { useEffect, useRef, useState } from 'react';
import OTPInput from 'otp-input-react';
import { useAuth } from '@/lib/auth';
import { showNotification } from '@/utils/notificationUtils';
import Utils from '@/utils/util';
import { ReactComponent as RefreshIcon } from '@/assets/img/v2/refresh.svg';
import './ConsumerLogin.scss';
import './ConsumerEmailVerification.scss';
import { useTranslation } from 'react-i18next';
import { useGenerateOTP } from '@/features/auth/api/generateOtp';
import { BackNav } from '@/components/BackNavigation/BackNavigation';
type EmailVerification = {
  onBack: (page: 'login') => void;
  onNext: (page: 'login' | 'email-verification' | 'parent-profile') => void;
};
export const EmailVerification = ({ onBack, onNext }: EmailVerification) => {
  const timerRef = useRef<any>();
  const { t } = useTranslation();
  const { login, user } = useAuth();
  const generateOtpMutation = useGenerateOTP();
  const [otp, setOtp] = useState('');
  const [remainingTime, setRemainingTime] = useState<number>(60);
  const emailFromStorage = localStorage.getItem('UsersEmail');

  useEffect(() => {
    Utils.scrollToTop();
  }, []);

  useEffect(() => {
    if (remainingTime > 0) {
      updateRemainingTime();
    } else {
      clearTimeout(timerRef.current);
    }
  }, [remainingTime]);
  const updateRemainingTime = () => {
    const interval = setTimeout(() => {
      setRemainingTime(remainingTime - 1);
    }, 1000);
    timerRef.current = interval;
  };
  const validate = () => {
    if (!otp || otp.trim().length < 6) {
      showNotification({
        type: 'info',
        title: t('Please enter 6 digit code'),
      });
      return false;
    }
    return true;
  };

  const verifyEmail = async () => {
    if (validate()) {
      const currentOtp = otp;
      const email = (user && user.email) || emailFromStorage;
      setOtp(''); 
      if (email) {
        await login({
          email: email.toLowerCase(),
          otp: currentOtp,
        });
        if (onNext) {
          onNext('parent-profile');
        }
      }
    }
  };

  const resendOtp = async () => {
    if (emailFromStorage) {
      await generateOtpMutation.mutateAsync({
        email: emailFromStorage ? emailFromStorage.toLowerCase() : '',
      });
    }
    setRemainingTime(60);
  };
  return (
    <section className="consumer-login verify-email">
      <div className="registration-container">
        <div>
          <BackNav onClick={() => onBack('login')} />
          <h5>{t('Verify Email')}</h5>
          <p className="desc">
            {t('Enter the 6-digit verification code we just sent you on your email')}{' '}
            <span>{user?.email ? user.email : emailFromStorage}</span>
          </p>
          <div className="otp-input-container">
            <span className="positioner">
              <OTPInput
                value={otp}
                onChange={setOtp}
                autoFocus
                OTPLength={6}
                otpType="number"
                className="otp-input-root"
                inputClassName="otp-input"
                disabled={false}
              />
              <span className="seperator">
                <span>-</span>
              </span>
            </span>
            <p className="missed-code">
              <p>{t('Missed the code? send again in')} </p>
              <span>
                {remainingTime > 0 ? (
                  <span className='timer'>{Utils.secondsToTime(remainingTime)}</span>
                ) : (
                  <span className="resend" onClick={resendOtp}>
                    {t('Resend Code')} <RefreshIcon />
                  </span>
                )}
              </span>
            </p>
          </div>
        </div>
        <div className="action">
          <button className="petsked-button button-dark" onClick={verifyEmail}>
            {t('Continue')}
          </button>
        </div>
      </div>
    </section>
  );
};
